export default "__VITE_ASSET__3722af56__"